// extracted by mini-css-extract-plugin
module.exports = {"container":"reference-navigation-container_container__Hq6ph"};